// @ts-ignore
import { GandalfArray } from 'gandalf';
// @ts-ignore
import { GandalfConstantDecorator } from 'gandalf';
// @ts-ignore
import { GandalfLabel } from 'gandalf';
// @ts-ignore
import { GandalfModel } from 'gandalf';
// @ts-ignore
import { GandalfModelBase } from 'gandalf';
// @ts-ignore
import { GandalfProperty } from 'gandalf';
// @ts-ignore
import { GandalfSubRequestLabel } from 'gandalf';
// @ts-ignore
import { GandalfValidator } from 'gandalf';
// @ts-ignore
import * as constants from '../constants';


/** See com.rev360.pms.api.controller.accounting.openedge.PaymentStoredTokenResponse */
/* istanbul ignore next */
@GandalfModel
export class PaymentStoredTokenResponse extends GandalfModelBase {

	@GandalfConstantDecorator(constants.PaymentMethodCreditCardType)
	@GandalfProperty({ designType: constants.PaymentMethodCreditCardType })
	cardType!: constants.PaymentMethodCreditCardType | null;

	@GandalfProperty({ designType: Number })
	expirationMonth!: number | null;

	@GandalfProperty({ designType: Number })
	expirationYear!: number | null;

	@GandalfProperty({ designType: String })
	maskedCardNumber!: string | null;

	@GandalfProperty({ designType: Number })
	paymentStoredTokenId!: number | null;

}
